<ng-container *ngIf="service?.category" [ngSwitch]="service?.category">
  <fin-included-product-item-summary-seat
    *ngSwitchCase="Category.SEAT"
    [passengers]="passengers"
    [bound]="bound"
    [service]="service"
  ></fin-included-product-item-summary-seat>
  <fin-included-product-item-summary-checked-bag *ngSwitchCase="Category.BAGGAGE" [summary]="bagsServicesSummary">
  </fin-included-product-item-summary-checked-bag>
  <fin-included-product-item-summary-other *ngSwitchDefault [summary]="otherServicesSummary">
  </fin-included-product-item-summary-other>
</ng-container>
